import { ShieldCheck, MessageSquare, Target, SlidersHorizontal, Clock, PoundSterling } from "lucide-react";
import { WHY_POINTS } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = [ShieldCheck, MessageSquare, Target, SlidersHorizontal, Clock, PoundSterling];

export default function WhyChoose() {
  return (
    <section className="py-20 md:py-28" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          overline="Why choose me"
          title="Big-company skills, without big-company costs"
          copy="You deal directly with the person doing the work — someone qualified, accountable to a professional code of conduct, and focused on outcomes rather than billable hours."
        />
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_POINTS.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={w.title} delay={Math.min(i * 0.06, 0.3)}>
                <div
                  data-testid={`why-card-${i}`}
                  className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-cyan-500/25"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600/15 text-blue-400">
                    <Icon size={19} strokeWidth={1.8} />
                  </span>
                  <h3 className="font-display mt-4 text-base font-semibold text-slate-50">{w.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{w.note}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
